export const REFERENCE_DEVICE_WIDTH = 428;
export const REFERENCE_DEVICE_HEIGHT = 870;
